import { FeedbackPrompt, GetFeedbackPrompt } from '@app/types'
import { executeQuerySideload } from '../graphql/apolloClient'
import { GET_FEEDBACK_PROMPT } from './feedbackQueries'

export async function getFeedbackPrompt(data: GetFeedbackPrompt): Promise<FeedbackPrompt> {
  const response = await executeQuerySideload(GET_FEEDBACK_PROMPT, { data })
  return response.feedback.getFeedbackPrompt
}
